export default __webpack_public_path__ + "images/give-a-gift.svg";